import React, { useEffect, useState } from "react";
import data from "../../assets/data/portofolioData";
import Modal from "./Modal";

const Portofolio = () => {
  const [nextItems, setNextItems] = useState(6);
  const [portofolios, setPortofolios] = useState(data);
  const [selectTab, setSelectTab] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [activeID, setActiveID] = useState(null);

  const loadMoreHandler = () => {
    setNextItems((prev) => prev + 3);
  };

  const showModalHandler = (id) => {
    setShowModal(true);
    setActiveID(id);
  };

  useEffect(() => {
    if (selectTab === "all") {
      setPortofolios(data);
    }
    if (selectTab === "ui-design") {
      const filteredData = data.filter((item) => item.category === "Ui");
      setPortofolios(filteredData);
    }
    if (selectTab === "front-end") {
      const filteredData = data.filter((item) => item.category === "Front End");
      setPortofolios(filteredData);
    }
    if (selectTab === "graphic-design") {
      const filteredData = data.filter((item) => item.category === "Graphic");
      setPortofolios(filteredData);
    }
  }, [selectTab]);

  return (
    <section id="portofolio">
      <div className="container">
        <div className="flex items-center justify-between flex-wrap">
          <div className="mb-7 sm:mb-0">
            <h3 className="text-headingColor text-[2rem] font-[700]">
              My Recent Project
            </h3>
          </div>

          <div className="flex gap-3">
            {/* All Tab Button */}
            <button
              onClick={() => setSelectTab("all")}
              className={`py-2 px-4 rounded-[8px] transition-colors duration-200
              ${
                selectTab === "all"
                  ? "bg-primaryColor text-white"
                  : "text-smallTextColor border border-solid border-smallTextColor"
              }`}
            >
              All
            </button>

            {/* UI/UX Design Tab Button */}
            <button
              onClick={() => setSelectTab("ui-design")}
              className={`py-2 px-4 rounded-[8px] transition-colors duration-200
              ${
                selectTab === "ui-design"
                  ? "bg-primaryColor text-white"
                  : "text-smallTextColor border border-solid border-smallTextColor"
              }`}
            >
              UI/UX Design
            </button>

            {/* Front End Tab Button */}
            <button
              onClick={() => setSelectTab("front-end")}
              className={`py-2 px-4 rounded-[8px] transition-colors duration-200
              ${
                selectTab === "front-end"
                  ? "bg-primaryColor text-white"
                  : "text-smallTextColor border border-solid border-smallTextColor"
              }`}
            >
              Front End
            </button>

            {/* Graphic Design Tab Button */}
            <button
              onClick={() => setSelectTab("graphic-design")}
              className={`py-2 px-4 rounded-[8px] transition-colors duration-200
              ${
                selectTab === "graphic-design"
                  ? "bg-primaryColor text-white"
                  : "text-smallTextColor border border-solid border-smallTextColor"
              }`}
            >
              Graphic Design
            </button>
          </div>
        </div>

        <div className="flex items-center gap-4 flex-wrap mt-12">
          {portofolios?.slice(0, nextItems)?.map((portofolio, index) => (
            <div
              key={index}
              data-aos="fade-zoom-in"
              data-aos-delay="50"
              data-aos-duration="1000"
              className="group max-w-full sm:w-[48.5%] md:w-[31.2%] lg:w-[32.2%] relative z-[1]"
            >
              <figure>
                <img className="rounded-[8px]" src={portofolio.imgUrl} alt="" />
              </figure>

              <div className="w-full h-full bg-primaryColor bg-opacity-40 absolute top-0 left-0 z-[5] hidden group-hover:block">
                <div className="w-full h-full flex items-center justify-center">
                  <button
                    onClick={() => showModalHandler(portofolio.id)}
                    className="text-white bg-headingColor hover:bg-smallTextColor py-2 px-4 rounded-[8px] font-[500] ease-in duration-200"
                  >
                    See Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-6">
          {nextItems < portofolios.length && data.length > 6 && (
            <button
              onClick={loadMoreHandler}
              className="text-white bg-primaryColor hover:bg-smallTextColor py-2 px-4 rounded-[8px] font-[500] ease-in duration-200"
            >
              Load More
            </button>
          )}
        </div>
      </div>

      {showModal && <Modal setShowModal={setShowModal} activeID={activeID} />}
    </section>
  );
};

export default Portofolio;
